<div class="contact-us-wrapper">
  <app-hero />
  <div class="form-and-map">
    <app-contact-form />
    <app-atrizult-map />
  </div>
  <app-socials class="app-socials-section" />
</div>
